import {Component, OnInit, Input, OnChanges, AfterViewInit, SimpleChanges} from '@angular/core';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import { ScriptService} from '../../../shared/services';
import { EnvServices } from '../../../shared/services/src/env.services';
import * as _ from 'lodash';
import {LanguageUtils} from '../../../shared/utils/src/language.utils';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {EnvLoadService} from '../../../env-load/env-load.service';
import {CommonServices, AgreementServices} from '../../../shared/services/src/api';
import {Subscription} from 'rxjs/Subscription';

const footer = require('./footer');
// const zendeskConfig = require('../../../shared/services/src/3rdPartyScript/zendeskConfig');

/*loadCldr(
    require('cldr-data/supplemental/numberingSystems.json'),
    require('cldr-data/main/ko/ca-gregorian.json'),
    require('cldr-data/main/ko/numbers.json'),
    require('cldr-data/main/ko/timeZoneNames.json'),
    require('cldr-data/main/en/ca-gregorian.json'),
    require('cldr-data/main/en/numbers.json'),
    require('cldr-data/main/en/timeZoneNames.json')
);*/

@Component({
    selector: 'app-main-footer',
    templateUrl: './footer.component.html',
    styleUrls: [ './footer.scss' ],
    providers: [ ScriptService, AgreementServices ]
})
export class FooterComponent implements OnInit {
    urls: any;
    subDomain: string;
    homepageInfo: any = {};

    private subscription: Subscription;
    // showChatbot = false;
    public isShowOpsBot: boolean = false;      // 상담서비스 노출 여부
    public site: String = '';     // 옵스봇 호출 호스트 정보
    public availableLangs = [];
    userLang = 'en';
    userLangNm = '';
    // zendeskUseFlag = false;
    public agreement = {
        agreementNo: 0,
        agreementTitle: '',
        agreementStatement: '',
        regDt: ''
    };
    public agreementList = [];
    agreementType = '';

    // public chatbotUrl: SafeResourceUrl;

    constructor(private translate: TranslateService,
                private _scriptService: ScriptService,
                private _commonServices: CommonServices,
                private sanitizer: DomSanitizer,
                public envServices: EnvServices,
                private envLoadService: EnvLoadService,
                private _agreementService: AgreementServices) {
        //setCulture('ko');
        /*if ($.cookie('BSP_LangCode')) {
            this.userLang = $.cookie('BSP_LangCode');
        } else {
            if (navigator.appVersion.indexOf('MSIE') > -1) { // Explorer
                this.userLang = navigator['userLanguage'].split('-')[0];
            } else {
                this.userLang = navigator.language.split('-')[0];
            }
        }*/
        //this.chatbotUrl = sanitizer.bypassSecurityTrustResourceUrl(environment.chatbotUrl);
        // this.chatbotUrl = sanitizer.bypassSecurityTrustResourceUrl(this.envLoadService.chatbotUrl);

        this.userLang = LanguageUtils.getLangCode();
        this.userLang = /(en|ko|zh|ja)/gi.test(this.userLang) ? this.userLang : 'en';

        this.userLang = LanguageUtils.choiceLanguage(this.userLang);

        //translate.setDefaultLang('en');
        translate.setDefaultLang(this.userLang);
        translate.use(this.userLang);

        this.site = location.hostname;
        //this.languageFlag(this.userLang);
        this.isShowOpsBot = this.whetherToShowOpsBot();
    }


    ngOnInit() {
        // this.zendeskUseFlag = this.envServices.getZendeskUseFlag();
        this.subscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            if (event.lang !== this.userLang) {
                this.userLang = event.lang;
                document.documentElement.lang = event.lang;
                this.whetherToShowOpsBot();
            }
        });

        const self = this;
        setTimeout(function(){
            footer.Footer.init();
            self.getHomepageInfo();
        }, 1);

        this.setSubDomain();
    }

    /*ngOnChanges(changes: SimpleChanges) {
        const chng = changes['homepageInfo'];
        if (chng !== undefined) {
            if (chng.currentValue !== undefined && (chng.currentValue !== chng.previousValue)) {
                this.getHomepageInfo();
            }
        }
    }*/

    // ngAfterViewInit() {
    //     setTimeout(() => {
    //         // if (location.host.indexOf('opsnow.com') > -1 && global['loginUser'].userEmail.indexOf('@bespinglobal.com') > -1) {
    //         this.chatbotShow();
    //     });
    //
    //     this._scriptService.initChatbot();
    // }

    // chatbotShow() {
    //     this.showChatbot = (location.host.indexOf('opsnow.com') > -1 && this.userLang === 'ko') ? true : false;
    // }

    public showOpsBot () {
        let js = document.getElementsByTagName('script')[0];
        const omj = document.getElementsByTagName('script')[0];

        if (document.getElementById('opsbot-js')) {
            return;
        }
        js = document.createElement('script');
        js.id = 'opsbot-js';
        js.src = 'https://bb8-server-prod.okc1.opsnow.com/api/scripts/opsbot.min.js';
        omj.parentNode.insertBefore(js, omj);
    }

    public whetherToShowOpsBot() {
        //if (location.hostname.indexOf('.opsnow.') > -1 || location.hostname.indexOf('.sec-alertnow.com') > -1) {
        //    this.showOpsBot();
        //    return true;
        //} else {
            // 차이나, WL 제외
            return false;
        //}
    }

    movePortal(actionUrl) {
        this.agreementType = this.getAgreementType(actionUrl);
        if (this.agreementType === 'privacy') {
            window.open(`https://www.opsnow.com/${this.userLang === 'ko' ? 'ko' : 'en'}/legal/privacy-policy`);
        } else {
            window.open(`https://www.opsnow.com/${this.userLang === 'ko' ? 'ko' : 'en'}/legal/terms-of-service`);
        }
        
    }

    private setSubDomain() {
        const subDomain: string[] =  window.location.href.replace('http://', '').replace('https://', '').split('/')[0].split(':')[0].split('.');
        subDomain[0] = '';
        //this.subDomain = '.' + subDomain[1] + '.' + subDomain[2];
        this.subDomain = subDomain.join('.');
    }

    selectLanguage(langCd, langNm) {
        this.userLangNm = langNm;
        const userLang = LanguageUtils.choiceLanguage(langCd);
        this.userLang = userLang;
    
        $.cookie('BSP_LangCode', userLang, { domain: this.subDomain, expires: 365, path: '/' });
    
        $('html').attr('lang', userLang);
    
        this.translate.use(userLang);
    
        $('#language > .btn-custom-select').removeClass('is-selected');
    
        const root = document.documentElement;
        switch (langCd) {  
            case 'en': 
                root.style.setProperty('--font-base-stack', "'Noto Sans Korean', 'Apple SD Gothic', sans-serif");
                root.style.setProperty('--font-special-stack', "'Montserrat','Noto Sans Korean', 'Apple SD Gothic', sans-serif");
                break;
            case 'ko': 
                root.style.setProperty('--font-base-stack', "'Noto Sans Korean', 'Apple SD Gothic', sans-serif");
                root.style.setProperty('--font-special-stack', "'Montserrat', 'Noto Sans Korean', 'Apple SD Gothic', sans-serif");
                break;
            case 'zh': 
                root.style.setProperty('--font-base-stack', "'Noto Sans SC', 'Microsoft YaHei', sans-serif");
                root.style.setProperty('--font-special-stack', "'Montserrat', 'Noto Sans SC', 'Microsoft YaHei', sans-serif");
                break;
            case 'ja': 
                root.style.setProperty('--font-base-stack', "'Meiryo'");
                root.style.setProperty('--font-special-stack', "'Meiryo'");
                break;
            default: 
                root.style.setProperty('--font-base-stack', "'Noto Sans Korean', 'Apple SD Gothic', sans-serif");
                root.style.setProperty('--font-special-stack', "'Montserrat','Noto Sans Korean', 'Apple SD Gothic', sans-serif");
        }
    }
    

    /*private getZelocale(lang) {
        switch (lang) {
            case 'ko':
                return 'ko';
            case 'zh':
                return 'zh-cn';
            case 'en':
                return 'en-US';
            default:
                return 'en-US';

        }
    }*/

    getHomepageInfo() {
        this._commonServices.getHomePageInfo().then(resp => {
            if (resp.status === 200) {
                const result = resp.json();
                this.homepageInfo = result;

                $('#footer_address_tel').html(this.homepageInfo['data'].footer.telCntrCd + ' ' + this.homepageInfo['data'].footer.telNo);
                $('#footer_company_registration_no').html(this.homepageInfo['data'].footer.corpRegNo);
                $('#footer_company_tel_sales_no').html(this.homepageInfo['data'].footer.mailOrdrSales);
                $('#footer_copyright').html(this.homepageInfo['data'].footer.copyRight);
                $('#footer_tech_tel').html(this.homepageInfo['data'].footer.techTelCntrCd + ' ' + this.homepageInfo['data'].footer.techTelNo);
                $('#footer_tech_email').html(this.homepageInfo['data'].footer.techEmail);
                const logo: any = this.homepageInfo['data'].logo;

                if (logo.mspCmpnLogoTypeCd === 'MSP_CMPN_LOGO_TYPE_010') {
                    $('#footer_title img').attr({
                        'src' : `${logo.logoFooter}`,
                        'alt' : `${logo.siteCd}`
                    });
                } else {
                    $('#footer_title').html(logo.logoFooterText);
                }

                this.availableLangs = this.homepageInfo['data'].availableLang;
                this.userLangNm = _.find(this.availableLangs, {'langCd': this.userLang})['langNm'];
            }
        });
    }

    moveSupport(_event) {
        _event.preventDefault();
        //window.open(environment.supportUrl);
        window.open(this.envLoadService.supportUrl);
    }

    getAgreementType(actionUrl) {
        return actionUrl.replace('/agreement/', '');
    }

    openModal() {
        this._agreementService.getAgreementContents(this.agreementType, this.userLang).then( res => {
            this.agreementList = res.json().data.agreementContents;
            this.agreement = this.agreementList[0];
        }).then(() => {
            const newWindow = window.open('');
            if (newWindow) {
                newWindow.document.write(`
                    <html>
                    <head>
                        <title>${this.agreement.agreementTitle}</title>
                        <style>
                        body {
                            font-family: Arial, sans-serif;
                            margin: 40px;
                            color: #333;
                            border: black 1px solid;
                        }
                        .layout-popup-title {
                            font-size: 28px;
                            font-weight: bold;
                            margin-bottom: 10px;
                            text-align: center;
                        }
                        .layout-popup-contents {
                            font-size: 16px;
                            line-height: 1.5;
                            margin: inherit;
                        }
                        h1, h2, h3 {
                            font-weight: bold;
                        }
                        h1 {
                            font-size: 24px;
                        }
                        h2 {
                            font-size: 20px;
                        }
                        h3 {
                            font-size: 18px;
                        }
                        p {
                            margin: 10px 0;
                        }
                        ul {
                            margin: 10px 0;
                            padding-left: 20px;
                        }
                        li {
                            margin: 5px 0;
                        }
                    </style>
                    </head>
                    <body>
                        <div class="layout-popup-title">
                            ${this.agreement.agreementTitle}
                        </div>
                        <div class="layout-popup-contents">
                            ${this.agreement.agreementStatement}
                        </div>
                    </body>
                    </html>
                `);
                newWindow.document.close();
            } else {
                console.error('Failed to open the new window. It might be blocked by the browser.');
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/GNB/footer/footer.component.ts